import { render, staticRenderFns } from "./ResidueClassification.vue?vue&type=template&id=d14453cc&scoped=true"
import script from "./ResidueClassification.vue?vue&type=script&lang=js"
export * from "./ResidueClassification.vue?vue&type=script&lang=js"
import style0 from "./ResidueClassification.vue?vue&type=style&index=0&id=d14453cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14453cc",
  null
  
)

export default component.exports